import EditProfile from "../edit-profile/EditProfile"

export default function EditProfilePage() {
    return (
        <EditProfile />
    )
};
